<template>
  <sliderBarDialogShell
    ref="sliderbar"
    :dialog-show="dialogShow"
    :dialog-title="title"
    :click-not-close="true"
    @close="beforeClose"
    @submit="confirm"
    class="edit-article-dialog"
  >
    <auth-form
      ref="outform"
      :is-edit="true"
      :product-list="productList"
      :form-data="rowData"
      @submit="submit"
    ></auth-form>
  </sliderBarDialogShell>
</template>

<script>
import authForm from "@/components/authorize/authForm";
import { editAuth } from "@/api/authorize";

export default {
  name: "editAuthDialog",
  components: {
    authForm,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
    productList: {
      type: Array,
      default(){
        return [];
      }
    },
    rowData: {
      type: Object,
      default(){
        return {}
      }
    }
  },
  data() {
    return {
      title: '编辑授权码'
    }
  },
  methods: {
    beforeClose() {
      this.$emit('close');
      this.$refs.outform.selfClear();
    },
    cancel() {
      this.beforeClose();
    },
    confirm() {
      this.$refs.outform.selfValidate();
    },
    submit(form) {
      let params = {
        id: form.id,
        userName: form.name,
        phone: form.phone,
        authorizedProducts: form.productType.join(','),
        beginDate: form.startTime,
        endDate: form.endTime,
      }
      if(form.recommender){
        params.referrer = form.recommender;
      }
      if(form.bindMac){
        params.bindMac = form.bindMac;
      }
      if(form.platform){
        params.bindPlatform = form.platform;
      }
      if(form.login){
        params.bindLogin = form.login;
      }
      if(form.type){
        params.type = form.type;
      }
      editAuth(params).then((res) => {
        if(res && res.code===200){
          this.$message({
            message: '编辑成功',
            type: 'success',
          });
          this.$refs.outform.selfClear();
          this.$emit('edit-success');
        }else {
          this.$message({
            message: res.msg,
            type: 'error'
          });
        }
      })
    }
  },
}
</script>

<style>
@media screen and (min-width: 768px) {
  .edit-article-dialog.sidebar-dialog .vs-sidebar {
    width: 800px;
  }
}
</style>
